import React from "react";
import { isEmpty, map } from "lodash";
import { Typography } from "antd";
import { AiccConversationFeedback } from "types/model/aiccCustomer";
import styles from "./Feedback.module.scss";

interface Props {
  feedback: AiccConversationFeedback;
}

const sections: { title: string; key: "achievements" | "suggestions" }[] = [
  { title: "Achievements", key: "achievements" },
  { title: "Suggestions", key: "suggestions" },
];

function Feedback({ feedback }: Props) {
  if (!feedback.summary && isEmpty(feedback.achievements) && isEmpty(feedback.suggestions)) {
    return <Typography.Paragraph type="secondary">No feedback available yet.</Typography.Paragraph>;
  }

  return (
    <div>
      {feedback.summary && <Typography.Paragraph>{feedback.summary}</Typography.Paragraph>}
      {map(sections, ({ title, key }) =>
        isEmpty(feedback[key]) ? null : (
          <div key={key}>
            <div className={styles.subSectionTitle}>{title}</div>
            <ul className={styles.itemList}>
              {map(feedback[key], (item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        )
      )}
    </div>
  );
}

export default Feedback;
